// extracted by mini-css-extract-plugin
export var actions = "_m9-5";
export var assistantBubble = "_m9-3";
export var assistantRow = "_m9-6";
export var bubble = "_m9-0";
export var humanAvatar = "_m9-4";
export var inlineToolCard = "_m9-1";
export var userBubble = "_m9-2";